import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBonusCodesList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceBonusCodeHdr: DataSource;
    tableBonusCodes: Table;
}
